const MS_IN_DAY = 24 * 60 * 60 * 1000

export function todayISO() {
  const now = new Date()
  return toISODate(now)
}

export function toISODate(date) {
  const copy = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  return copy.toISOString().slice(0, 10)
}

export function parseISODate(value) {
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function formatDate(value) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(parseISODate(value))
}

export function formatShortDate(value) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: 'short' }).format(parseISODate(value))
}

export function formatCurrency(value, currency = '₽') {
  const number = Number.isFinite(Number(value)) ? Number(value) : 0
  return `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(number)} ${currency}`
}

export function formatNumber(value, digits = 1) {
  const number = Number.isFinite(Number(value)) ? Number(value) : 0
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: digits }).format(number)
}

export function getWeekPeriod(dateISO, weekStartsOn = 1) {
  const date = parseISODate(dateISO)
  const day = date.getDay() || 7
  const normalizedWeekStart = weekStartsOn === 0 ? 7 : weekStartsOn
  const diff = day >= normalizedWeekStart ? day - normalizedWeekStart : 7 - (normalizedWeekStart - day)
  const start = new Date(date.getTime() - diff * MS_IN_DAY)
  const end = new Date(start.getTime() + 6 * MS_IN_DAY)
  return {
    key: `${toISODate(start)}_${toISODate(end)}`,
    start: toISODate(start),
    end: toISODate(end)
  }
}

export function isDateInside(dateISO, fromISO, toISO) {
  if (fromISO && dateISO < fromISO) return false
  if (toISO && dateISO > toISO) return false
  return true
}

export function addDays(dateISO, days) {
  const date = parseISODate(dateISO)
  date.setDate(date.getDate() + days)
  return toISODate(date)
}

export function getPayoutDate(periodEndISO, settings) {
  const base = parseISODate(periodEndISO)
  base.setDate(base.getDate() + Number(settings.payoutDelayWeeks || 0) * 7)
  const target = Number(settings.payoutDay || 2)
  const current = base.getDay() || 7
  const normalizedTarget = target === 0 ? 7 : target
  const diff = normalizedTarget >= current ? normalizedTarget - current : 7 - (current - normalizedTarget)
  base.setDate(base.getDate() + diff)
  return toISODate(base)
}

export function sortByDateDesc(a, b) {
  return String(b.date || b.effectiveFrom || '').localeCompare(String(a.date || a.effectiveFrom || ''))
}

export function monthKey(dateISO) {
  return dateISO.slice(0, 7)
}

export function timeToMinutes(time) {
  if (!time) return null
  const [hours, minutes] = time.split(':').map(Number)
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null
  return hours * 60 + minutes
}
